<button mat-raised-button color="primary" class="d-block mx-auto plain">
  <mat-icon>arrow_forward</mat-icon>
  <ng-content></ng-content>
</button>